import { Clipboard } from '@angular/cdk/clipboard';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GetLanguage } from '../../shared/actions/eliqua.actions';
import { ActivityLogService } from '../../shared/services/activity-log.service';
import { EnvironmentFacadeService } from '../../shared/services/environment.facade.service';
import { LiteralsService } from '../../shared/services/literals.service';

export interface AvailableLanguage {
  languageId: number;
  languageCode: string;
  languageName: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  selectedLanguage = 'en';
  availableLanguages: AvailableLanguage[] = [];
  isDarkMode = false;
  copiedEntryId: number | null = null;
  private copyTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private router: Router,
    private store: Store,
    private environmentFacade: EnvironmentFacadeService,
    private literalsService: LiteralsService,
    private clipboard: Clipboard,
    public activityLog: ActivityLogService,
  ) {}

  ngOnInit(): void {
    this.selectedLanguage = localStorage.getItem('lang') || 'en';
    this.isDarkMode = localStorage.getItem('theme') === 'dark';
    if (this.isDarkMode) {
      document.body.setAttribute('data-theme', 'dark');
    }
    this.literalsService.getAvailableLanguages().subscribe((langs) => {
      this.availableLanguages = langs;
    });
  }

  goHome(): void {
    this.router.navigate(['/homepage']);
  }

  get selectedLanguageName(): string {
    const found = this.availableLanguages.find((l) => l.languageCode === this.selectedLanguage);
    return found ? found.languageName : this.selectedLanguage;
  }

  changeLanguage(lang: AvailableLanguage): void {
    localStorage.setItem('lang', lang.languageCode);
    this.selectedLanguage = lang.languageCode;
    this.store.dispatch(GetLanguage());
  }

  toggleDarkMode(): void {
    this.isDarkMode = !this.isDarkMode;
    if (this.isDarkMode) {
      document.body.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.removeAttribute('data-theme');
      localStorage.setItem('theme', 'light');
    }
  }

  copyEntryCode(entry: { id: number; copyValue?: string }, event: Event): void {
    event.stopPropagation();
    if (!entry.copyValue) return;
    this.clipboard.copy(entry.copyValue);
    this.copiedEntryId = entry.id;
    if (this.copyTimer) clearTimeout(this.copyTimer);
    this.copyTimer = setTimeout(() => (this.copiedEntryId = null), 2000);
  }

  logout(): void {
    const idpUrl = this.environmentFacade.IDP();
    window.location.replace(idpUrl);
  }
}
